module.exports = __webpack_public_path__ + "img/Natur.85df6fe4.jpg";